import React, { useEffect, useState } from 'react';
import BarChart from './BarChart';
import { Box, Grid, Typography } from '@mui/material';
import { Inventory } from '@mui/icons-material';
import { GET_SETTING } from 'src/apiService/apiDeclaration';
import { t } from 'i18next';

const InventorySection = () => {
  const [data, setData] = useState();
  const getInventoryReport = async () => {
    try {
      let resp = await GET_SETTING();
      setData(resp.data);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    getInventoryReport();
  }, []);
  const chartData = [
    { material: t('inventoryPage.cement'), value: data?.currentCement || 0 },
    { material: t('inventoryPage.sand'), value: data?.currentSand || 0 },
    { material: t('inventoryPage.gravel815'), value: data?.currentGravel815 || 0 },
    { material: t('inventoryPage.gravel1525'), value: data?.currentGravel1525 || 0 },
  ];
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Inventory sx={{ fontSize: '2.5rem', color: '#acd629' }} />
        <Typography variant="h4">{t('dashboard.stockLevel')}</Typography>
      </Grid>
      <BarChart
        data={chartData}
        label={t('dashboard.inventoryLevels')}
        xLabel={t('dashboard.materialType')}
        yLabel={t('dashboard.volInStock')}
        valueKey="value"
        color={(ctx) => (ctx.raw > 0 ? '#88C070' : '#F44336')}
      />
    </Box>
  );
};

export default InventorySection;
